import { Button, Checkbox, Stack, TextField } from "@mui/material";
import {
  DashBoardDateRangePicker,
  InputControl,
  LimitedTag,
} from "../../../shared";
import { AppContext } from "../../../store";
import { useContext, useState } from "react";
import { useImmer } from "use-immer";

const initialDateState = {
  range: [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ],
  showRange: [],
};

export const FilterSection = ({ moduleName }) => {
  // Accessing global app context
  const { setTableState, tableData, clearAllFilters, globalData } =
    useContext(AppContext);
  const appliedFilters = tableData[moduleName]?.data;
  const dateRange =
    appliedFilters?.date?.length > 0
      ? [
          {
            ...appliedFilters.date[0],
            startDate: new Date(appliedFilters.date[0].startDate),
            endDate: new Date(appliedFilters.date[0].endDate),
          },
        ]
      : [];

  const today = new Date();
  const [open, setOpen] = useState(false);
  const [date, setDate] = useImmer({
    range: dateRange.length > 0 ? dateRange : initialDateState.range,
    showRange: dateRange,
  });

  // Handler to change the filter state
  const onChange = (event) => {
    const { name, value } = event.target;
    setTableState({
      tableName: moduleName,
      key: name,
      value: value,
    });
  };

  // Handler to reset the filter
  const resetFilter = () => {
    clearAllFilters({ tableName: moduleName });
    setDate(initialDateState);
  };

  const disableClearButton =
    appliedFilters?.status !== null ||
    appliedFilters?.type?.length > 0 ||
    appliedFilters?.date?.length > 0
      ? false
      : true;

  return (
    <Stack flexDirection="row" flexWrap="wrap" gap="8px">
      <DashBoardDateRangePicker
        onChangeDate={(event) => {
          setDate((draft) => {
            draft.range = event;
            draft.showRange = event;
          });
        }}
        range={date.range}
        showRange={date.showRange}
        isOpen={open}
        handleIsOpen={setOpen}
        handleDateChangeApply={(e) => {
          onChange({
            target: {
              name: "date",
              value: date.showRange,
            },
          });
          setOpen(false);
        }}
        text="Date"
        isInverted={true}
        minDate={today}
      />
      <InputControl
        type="dropdown"
        variant="filter"
        size="small"
        options={globalData?.ReferenceStatus || []}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        sx={{
          width: "150px",
        }}
        value={appliedFilters?.status}
        renderInput={(params) => <TextField {...params} placeholder="Status" />}
        onChange={(event, option) =>
          onChange({ target: { name: "status", value: option } })
        }
      />
      <InputControl
        type="dropdown"
        variant="filter"
        size="small"
        multiple
        options={globalData?.Ingredient_types || []}
        value={appliedFilters?.type}
        disableCloseOnSelect
        disableClearable={true}
        onChange={(event, option) =>
          onChange({ target: { name: "type", value: option } })
        }
        getOptionLabel={(option) => option.label || ""}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderTags={(value) => <LimitedTag value={value} labelKey="label" />}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option.id}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            {option.label}
          </li>
        )}
        // filterOptions={filterOptions}
        sx={{ width: "200px" }}
        renderInput={(params) => <TextField {...params} placeholder="Type" />}
      />
      <Button
        type="button"
        size="small"
        variant="text"
        sx={{
          p: "6px 12px 6px 12px",
          gap: "6px",
        }}
        disabled={disableClearButton}
        onClick={resetFilter}
      >
        Clear All
      </Button>
    </Stack>
  );
};
